import type { SpecViewer } from './useSpecDraft'
import { viewerClassId, viewerColor, whereText } from './presenceMarks'

// 공동 편집 접속자 표시 — 머리의 얼굴 목록, 디바이스 행·탭의 이름표

/** 지금 이 명세서를 보고 있는 사람 (나 포함) */
export function ViewerAvatars({ viewers, me }: { viewers: SpecViewer[]; me: string | null }) {
  if (viewers.length <= 1) return null
  return (
    <div className="flex -space-x-1.5" title="지금 이 명세서를 보고 있는 사람">
      {viewers.map(v => (
        <span key={v.connectionId} title={`${v.name}${v.connectionId === me ? ' (나)' : ` · ${whereText(v)}`}`}
          className="w-6 h-6 rounded-full border-2 border-surface text-[10px] font-semibold text-white flex items-center justify-center"
          style={{ background: viewerColor(v) }}>
          {v.name.slice(0, 1)}
        </span>
      ))}
    </div>
  )
}

/** 이 디바이스에서 작업 중인 다른 사람 — 이름표 (행 끝·탭) */
export function ViewerChips({ viewers, compact }: { viewers: SpecViewer[]; compact?: boolean }) {
  if (viewers.length === 0) return null
  return (
    <span className="inline-flex items-center gap-0.5">
      {viewers.map(v => (
        <span key={v.connectionId} title={`${v.name} · ${whereText(v)} 중`}
          className={`rounded-full text-white font-semibold leading-none whitespace-nowrap ${compact ? 'w-4 h-4 text-[9px] flex items-center justify-center' : 'px-1.5 py-0.5 text-[10px]'}`}
          style={{ background: viewerColor(v) }}>
          {compact ? v.name.slice(0, 1) : v.name}
        </span>
      ))}
    </span>
  )
}

/** 칸 이름표 — 다른 사람이 있는 칸 위에 그 사람 이름 (입력 중이면 늘, 아니면 마우스를 올렸을 때). index.css 의 presence-cell */
export function PresenceNames({ viewers }: { viewers: SpecViewer[] }) {
  const css = viewers.map(v => {
    const label = `${v.name}${v.cursor?.editing ? ' 입력 중' : ''}`.replace(/[\\"\n<>]/g, ' ')
    return `.spec-grid .presence-v-${viewerClassId(v)} { --presence-name: "${label}"; }`
  }).join('\n')
  return <style>{css}</style>
}
